__turbopack_context__.v({
  "author": "style-module-scss-module__w80nXq__author",
  "card": "style-module-scss-module__w80nXq__card",
  "divider": "style-module-scss-module__w80nXq__divider",
  "greenTheme": "style-module-scss-module__w80nXq__greenTheme",
  "number": "style-module-scss-module__w80nXq__number",
  "numbered": "style-module-scss-module__w80nXq__numbered",
  "text": "style-module-scss-module__w80nXq__text",
  "title": "style-module-scss-module__w80nXq__title",
});
